// extracted by mini-css-extract-plugin
export default {"m":"_958087906a","title":"_79dafcda2b","feedback_inner_title":"d53a4a35af","textarea":"_418c75e046","radio":"_1127400a4f","text":"_26d33ca193"};